{
    "AuthoriseButton_Title": "Authorise",
    "PreAuthoriseButton_Title": "Pre-Authorise",
    "Authentication_PreAuthorisation_Successful": "Pre-Authorised",
    "Authentication_Successful": "Authorisation Granted",
    "Authentication_Failed": "The Authorisation process has failed.",
    "Authentication_Authenticated": "This Telephony Server has already been authorised.",
    "Authentication_CrmAuthenticated": "This CRM has already been authorised.",
    "Authentication_Status_Title": "Auth Status",
    "Authentication_Status_Warning": "There is a warning for this authorisation, you can try to re-authorise to fix this.",
    "Authentication_Status_Warning_Range_30100_30199": "Authorisation Successful, but a problem has been detected communicating with MS Teams. Please contact Akixi customer support.",
    "Authentication_Status_Warning_Range_30200_30299": "Authorisation Successful, but a problem has been detected synchronising with MS Teams. Please contact Akixi customer support.",
    "NAME": "OAuthButton"
}
